import { render, staticRenderFns } from "./ImplementationStateChip.vue?vue&type=template&id=5451a2ab"
import script from "./ImplementationStateChip.vue?vue&type=script&lang=ts"
export * from "./ImplementationStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports